import { useParams } from "react-router-dom";
import { QRCodeAnswersViewModel } from "./QRCodeAnswersViewModel";
import { provideGetAnswerUseCase } from "../../../di/UseCasesModule";
import { CircularProgress, Stack } from "@mui/material";
import { LoadingView } from "../../../component/LoadingView";
import { EmptyView } from "../../../component/EmptyView";
import { CustomTextView } from "../../../component/CustomTextView";
import { AttachmentView } from "../../game/question/QuestionAnswerDetailsView";
import useWindowDimensions from "../../../../core/utils/UseWindowDimensions";
import { COLOR_MAIN } from "../../../../data/colors/Colors";
import { CustomCardView } from "../../../component/CustomCardView";
import { CustomImageView } from "../../../component/CustomImageView";
import { CustomButtonView } from "../../../component/CustomButtonView";
import { useTranslation } from "react-i18next";
import { BoardView } from "../canvas/BoardView";
import { useEffect } from "react";

export function QRCodeAnswersView() {
  const { id } = useParams();
  const viewModel = QRCodeAnswersViewModel(id, provideGetAnswerUseCase());
  const { width } = useWindowDimensions();

  const { t } = useTranslation();
  return (
    <Stack
      p={2}
      minHeight={"80vh"}
      justifyContent={"center"}
      alignItems={"center"}
      gap={1}
      overflow={viewModel.isDrawingStarted ? "hidden" : "auto"}
    >
      {viewModel.loading ? (
        <LoadingView minHeight="40vh" />
      ) : viewModel.answer ? (
        <>
          {viewModel.isDrawingStarted ? (
            <Stack gap={2} alignItems={"center"}>
              {viewModel.readyToDraw ? (
                <>
                  <CustomTextView
                    text={viewModel.answer.title}
                    fontWeight="bold"
                    variant="h4"
                    textAlign="center"
                  />
                  <BoardView onDrawEnded={viewModel.onDrawEnded} />
                </>
              ) : (
                <>
                  <CustomTextView text="Waiting for ready button to be clicked!" variant="h6" fontWeight="bold"/>
                  <CircularProgress sx={{ color: COLOR_MAIN }} />
                </>
              )}
            </Stack>
          ) : (
            <Stack gap={2} alignItems={"center"} width={"100%"}>
              <CustomImageView
                src={require("../../../../assets/images/icon_transparent.PNG")}
                width={200}
                height={200}
                props={{ borderRadius: 4 }}
              />
              <Stack
                gap={12}
                p={4}
                width={"100%"}
                alignItems={"center"}
                justifyContent={"center"}
                borderRadius={4}
                bgcolor={COLOR_MAIN}
              >
                <CustomTextView
                  text={viewModel.answer.title}
                  fontWeight="bold"
                  variant="h3"
                  textColor="white"
                  textAlign="center"
                />
                {viewModel.answer.attachment && (
                  <AttachmentView
                    attachment={viewModel.answer.attachment}
                    isMobile={width < 900}
                  />
                )}
              </Stack>

              {viewModel.isDrawingMode && (
                <CustomButtonView
                  text={t("start_drawing")}
                  onClick={viewModel.drawingStarted}
                  fontSize="h6"
                />
              )}
            </Stack>
          )}
        </>
      ) : (
        <EmptyView minHeight={"100vh"} />
      )}
    </Stack>
  );
}
